export enum View {
  SELECT_CONTACT_OPTION = 'SELECT_CONTACT_OPTION',
  CHAT_SIGN_IN = 'CHAT_SIGN_IN',
  CALL_SIGN_IN = 'CALL_SIGN_IN',
  CHAT = 'CHAT',
  CALL = 'CALL',
  RATING = 'RATING',
  RATING_SUBMITTED = 'RATING_SUBMITTED',
  CALL_SUBMITTED = 'CALL_SUBMITTED'
}
